// Community-call start times for the home page's "Community calls & events"
// section. Each call is pinned to one clock, US Eastern or UTC, and the page
// shows both; `callClock` derives the one that isn't pinned.

const EASTERN = 'America/New_York';

// Hours to add to an Eastern wall-clock time to get UTC: 4 under EDT, 5 under
// EST. Derived from the tz database via Intl rather than hardcoded, so the
// published times stay right across a daylight-saving change without a
// redeploy. Prerendered HTML carries the build-time value; hydration corrects
// it in the browser. Reading the offset "now" rather than at the call's own
// hour can be off by one for a few hours on a changeover day — the tradeoff
// for not shipping a tz library.
const easternToUtcOffset = now => {
  const asUtc = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));
  const asEastern = new Date(now.toLocaleString('en-US', { timeZone: EASTERN }));
  return Math.round((asUtc - asEastern) / 3600000);
};

const shiftHours = (time, offset) => {
  const [hours, minutes] = time.split(':').map(Number);
  const shifted = (hours + offset + 24) % 24;
  return `${String(shifted).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

// `{ eastern: '08:00' }` or `{ utc: '14:00' }` → `{ utc, eastern }`, both "HH:MM".
export const callClock = ({ utc, eastern }, now = new Date()) => {
  const offset = easternToUtcOffset(now);
  return {
    utc: utc ?? shiftHours(eastern, offset),
    eastern: eastern ?? shiftHours(utc, -offset),
  };
};
